
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GlassCard } from './ui/GlassCard';
import { Cookie } from 'lucide-react';

export const CookieConsent: React.FC = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            // Small delay for animation entrance
            const timer = setTimeout(() => setVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'true');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-4 left-4 right-4 z-[90] flex justify-center animate-in slide-in-from-bottom-4 duration-700 pointer-events-none">
            <GlassCard className="max-w-3xl w-full flex flex-col md:flex-row items-center justify-between gap-6 border-t border-white/20 shadow-2xl bg-black/90 backdrop-blur-xl pointer-events-auto p-6">
                <div className="flex items-start gap-4">
                    <div className="p-3 bg-white/10 rounded-full text-white shrink-0">
                        <Cookie size={24} />
                    </div>
                    <div className="text-xs text-neutral-300">
                        <p className="font-bold text-white uppercase tracking-widest mb-1">Cookie Notice</p>
                        <p className="leading-relaxed">
                            We use cookies to ensure you get the best experience on our platform. 
                            These are essential for authentication, payments, and site functionality. 
                            By continuing, you agree to our <Link to="/privacy" className="text-white underline hover:text-neutral-300">Privacy Policy</Link> and <Link to="/eula" className="text-white underline hover:text-neutral-300">EULA</Link>.
                        </p>
                    </div>
                </div>
                <div className="flex gap-3 w-full md:w-auto shrink-0">
                    <button 
                        onClick={handleAccept}
                        className="flex-1 md:flex-none px-8 py-3 bg-white text-black font-bold uppercase tracking-widest text-xs rounded-sm hover:bg-neutral-200 transition-colors shadow-lg whitespace-nowrap"
                    >
                        Accept & Continue
                    </button>
                </div>
            </GlassCard>
        </div>
    );
};
